import styled from 'styled-components';

export const Container = styled.div`
  display: block;

  .ant-card-body img {
    max-width: 100%;
}
`;
